const HOME = "/";
const COUNTRY = "/country/:countryId";
const SING_UP = "/signup";
const SING_IN = "/signin";
const TOP_PLACE_RATING = "/top-places";

export default { HOME, COUNTRY, SING_UP, SING_IN, TOP_PLACE_RATING };
